var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.11304 0.5H9.9051C12.3271 0.5 14.0181 2.16904 14.0181 4.56091V11.4391C14.0181 13.831 12.3271 15.5 9.9051 15.5H4.11304C1.69102 15.5 0 13.831 0 11.4391V4.56091C0 2.16904 1.69102 0.5 4.11304 0.5ZM17.958 2.87899C18.397 2.65564 18.912 2.67899 19.331 2.94295C19.75 3.20589 20 3.66275 20 4.16224V11.8384C20 12.3389 19.75 12.7947 19.331 13.0577C19.102 13.2008 18.846 13.2739 18.588 13.2739C18.373 13.2739 18.158 13.2232 17.957 13.1206L16.4759 12.3734C15.9279 12.0952 15.5879 11.5369 15.5879 10.9166V5.08305C15.5879 4.46173 15.9279 3.90335 16.4759 3.62721L17.958 2.87899Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.75f60ce9.svg";
export { ForwardRef as ReactComponent };